import { render } from "./BidList.vue?vue&type=template&id=2b3c407c&scoped=true"
import script from "./BidList.vue?vue&type=script&lang=js"
export * from "./BidList.vue?vue&type=script&lang=js"

import "./BidList.vue?vue&type=style&index=0&id=2b3c407c&lang=css"
import "./BidList.vue?vue&type=style&index=1&id=2b3c407c&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3c407c"]])

export default __exports__